'use client';

import { EnergyType } from '@energy-retailer/constants';
import { useRouter } from 'next/navigation';

import { trackAnalyticsEvent } from '@/app/lib/analytics';
import { Button } from '@/components/button';
import { ANALYTICS_EVENTS } from '@/constants';
import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';

type OptOutOfFuelButtonProps = {
  fuel: EnergyType;
};

function OptOutOfFuelButton({ fuel }: Readonly<OptOutOfFuelButtonProps>) {
  const router = useRouter();
  const {
    removeStep,
    setCheckboxChecked,
    steps,
    gasPlanSlug,
    electricityPlanSlug,
  } = useJoinFormStore();

  const hasPlan = Boolean(gasPlanSlug) || Boolean(electricityPlanSlug);

  function conditionallyGoToSignUp() {
    if (steps.length === 2 && hasPlan) {
      router.push('/sign-up/details');
      return true;
    }

    return false;
  }

  return steps.length === 2 ? (
    <div className="flex items-center justify-center">
      <Button
        variant="secondary"
        onClick={() => {
          if (fuel === EnergyType.Electricity) {
            trackAnalyticsEvent(
              ANALYTICS_EVENTS.compareEnergyPlans.fuelNotRequired.electricity,
              {}
            );
          } else {
            trackAnalyticsEvent(
              ANALYTICS_EVENTS.compareEnergyPlans.fuelNotRequired.gas,
              {}
            );
          }

          removeStep(fuel);
          setCheckboxChecked(fuel, false);

          const shouldGoToSignUp = conditionallyGoToSignUp();

          if (!shouldGoToSignUp) {
            window.scrollTo({ top: 0 });
          }
        }}
      >
        I don&apos;t require{' '}
        {fuel === EnergyType.Electricity ? 'electricity' : 'gas'}
      </Button>
    </div>
  ) : null;
}

export { OptOutOfFuelButton };
